import React from 'react';

export default class BlockNumber extends React.Component{
  render(){
    return (<span className="c-block-number" data-tip="Block number">{this.props.blockNumber}</span>);
  }
}



// WEBPACK FOOTER //
// ./src/components/Components/BlockNumber.js